<script lang="ts">
	import IKS from "./IKS.svelte";
	import { CircleWithWarning, AdaptiveTextInput, XIcon } from "@hitit/new_ui";
	// Utils
	import { t } from "@hitit/hub/src/stores";
	import { createEventDispatcher } from "svelte";

	export let insta = "";
	export let naverBlog = "";
	export let youtube = "";
	export let editmode = false;

	type sns = "insta" | "naver" | "youtube";

	const dispatch = createEventDispatcher();
	const xHandler = (sns: sns) =>
		dispatch("SNS_UPDATE", { type: sns, value: "" });
	const inputHandler = (e: Event, sns: sns) => {
		const value = (e.target as HTMLInputElement).value;
		dispatch("SNS_UPDATE", {
			type: sns,
			value,
		});
	};

</script>

<IKS name={'SNS'} slotHasPadding>
	<img
		src="/img/icons/placeSNS.png"
		alt="SNS Icon"
		slot="image"
		class="iks-image" />
	<div class="container">
		{#if editmode}
			<div class="input-container">
				<img
					src="/img/icons/place_insta.png"
					alt="insta icon"
					class="link-image" />
				<div class="input-box">
					<AdaptiveTextInput
						on:input={(e) => inputHandler(e, 'insta')}
						value={insta}
						noFocusoutline
						backgroundColor={'transparent'}
						placeholder={$t('hub.place.SNS.insta_placeholder')}>
						<div class="x-icon" slot="clear" on:click={() => xHandler('insta')}>
							<XIcon />
						</div>
					</AdaptiveTextInput>
				</div>
			</div>
			<div class="input-container">
				<img
					src="/img/icons/place_blog.png"
					alt="insta icon"
					class="link-image" />
				<div class="input-box">
					<AdaptiveTextInput
						on:input={(e) => inputHandler(e, 'naver')}
						value={naverBlog}
						noFocusoutline
						backgroundColor={'transparent'}
						placeholder={$t('hub.place.SNS.naver_placeholder')}>
						<div class="x-icon" slot="clear" on:click={() => xHandler('naver')}>
							<XIcon />
						</div>
					</AdaptiveTextInput>
				</div>
			</div>
			<div class="input-container">
				<img
					src="/img/icons/place_youtube.png"
					alt="insta icon"
					class="link-image" />
				<div class="input-box">
					<AdaptiveTextInput
						on:input={(e) => inputHandler(e, 'youtube')}
						value={youtube}
						noFocusoutline
						backgroundColor={'transparent'}
						placeholder={$t('hub.place.SNS.youtube_placeholder')}>
						<div
							class="x-icon"
							slot="clear"
							on:click={() => xHandler('youtube')}>
							<XIcon />
						</div>
					</AdaptiveTextInput>
				</div>
			</div>
		{:else if !insta && !naverBlog && !youtube}
			<div class="no-sns">
				<div class="circle">
					<CircleWithWarning />
				</div>
				<p class="desc">{$t('hub.place.No_SNS')}</p>
			</div>
		{:else}
			{#if insta}
				<div class="link-container">
					<img
						src="/img/icons/place_insta.png"
						alt="insta icon"
						class="link-image" />
					<a href={`https://www.instagram.com/${insta}/`}>{insta}</a>
				</div>
			{/if}
			{#if naverBlog}
				<div class="link-container">
					<img
						src="/img/icons/place_blog.png"
						alt="blog icon"
						class="link-image" />
					<a href={`https://blog.naver.com/${naverBlog}/`}>{naverBlog}</a>
				</div>
			{/if}
			{#if youtube}
				<div class="link-container">
					<img
						src="/img/icons/place_youtube.png"
						alt="youtube icon"
						class="link-image" />
					<a href={youtube}>{youtube}</a>
				</div>
			{/if}
		{/if}
	</div>
</IKS>

<style lang="scss">
	@import "../../../variables.scss";
	.iks-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		color: #46474b;
		.no-sns {
			display: flex;
			align-items: center;
			gap: 10px;

			.circle {
				width: 20px;
				height: 20px;
			}
		}

		.link-container {
			display: flex;

			gap: 10px;

			a {
				color: #6d6f76;
				text-decoration: underline solid #6d6f76;
				text-underline-offset: 2px;
				&:visited {
					color: #6d6f76;
				}
			}
		}
		.input-container {
			display: flex;
			gap: 10px;
			align-items: center;

			.input-box {
				background-color: #f0f0f4;
				border-radius: 20px;
				flex-grow: 1;
				height: 30px;
				color: #6d6f76;

				.x-icon {
					width: 16px;
					height: 16px;
				}
			}
		}

		.link-image {
			width: 20px;
			height: 20px;
			object-fit: contain;
		}
	}
	@include DesktopSize {
		.container {
			.no-sns {
				.circle {
					width: 24px;
					height: 24px;
				}
				.desc {
					font-size: 1.25rem;
				}
			}
			.input-container {
				.input-box {
					padding: 3px 5px;
					box-sizing: border-box;
					flex-grow: 1;
					height: 40px;
					color: #6d6f76;
					font-size: 1.125rem;
					max-width: 370px;
				}
			}
			.link-container {
				a {
					font-size: 1.125rem;
				}
			}
		}
	}

</style>
